import React from 'react';
import './index.scss';

import { FaCaretLeft } from 'react-icons/fa';
import FormButton from '../../style/styledComponents/FormButton';
import { GrLinkPrevious } from 'react-icons/gr';

export default function NavButton({
	goForward,
	goBack = () => {},
	goForwardText,
	goBackText,
	style,
	disabled,
	step
}) {
	// console.debug('props', props);
	const disabledClass = disabled ? 'isDisabled ' : '';
	style = style ? style : '';
	return (
		<FormButton>
			<div>
				{goForward ? (
					step ? (
						disabled ? (
							<div className='row btn-mobile'>
								<button onClick={goForward} className={disabledClass}>
									<span>{goForwardText}</span>
								</button>
							</div>
						) : (
							<div className='row btn-mobile'>
								<button onClick={goForward} className={`btn-forward ${style}`}>
									<span className={disabledClass}>{goForwardText}</span>
								</button>
							</div>
						)
					) : disabled ? (
						<div className='row btn-mobile'>
							<button onClick={''} className={disabledClass}>
								<span>{goForwardText}</span>
							</button>
						</div>
					) : (
						<div className='row btn-mobile'>
							<button onClick={goForward} className={`btn-forward ${style}`}>
								<span className={disabledClass}>{goForwardText}</span>
							</button>
						</div>
					)
				) : (
					''
				)}
			</div>
			{goBackText ? (
				<button className='btn-back' onClick={goBack}>
					{/*<GrLinkPrevious size={0} />*/}
					<strong>{goBackText}</strong>
				</button>
			) : (
				''
			)}
		</FormButton>
	);
}
